module.exports = __webpack_public_path__ + "img/901668625.d2ed3da5.png";